import React from "react";
import AxiomApp from "./AxiomApp";
import AxiomLayoutComponent from "./AxiomLayoutComponent";
import "./i18n";
import { useTranslation } from "react-i18next";

export default function AxiomLayout(props) {
  const { t, i18n } = useTranslation(["translation", "kpitranslation"]);
  if (AxiomAPIs != null) {
    AxiomAPIs.translate = t;
  }
  if (props.layoutName === "AxiomApp") {
    return <AxiomApp {...props} i18n={i18n} />;
  } else {
    return <AxiomLayoutComponent {...props} i18n={i18n} />;
  }
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then((boolean) => {
          console.info("SW unregistered: ", boolean);
        });
      }
    });
  });
}
